import React from "react";
import PropTypes from "prop-types";

function EstablishmentManagers(props) {
    const { establishment } = props;

    if (!establishment.managers.length) {
        return false;
    }

    return (
        <section className="layer bg--neutral-xlight">
            <div className="image-content image-content--rev image-content--mobile-rev sign-inv">
                <div className="site-width">
                    <div className="layout layout--fit layout--gutter layout--middle layout--rev">
                        <div className="layout__cell unit-6-12--gt-palm unit-1-1 sign">
                            {establishment.ambianceImage["1000x563"] &&
                                establishment.ambianceImage["2000x1125"] && (
                                    <figure className="image-content__visual visual">
                                        <picture
                                            className="picture"
                                            data-default-src={
                                                establishment.ambianceImage[
                                                    "1000x563"
                                                ]
                                            }
                                        >
                                            <source
                                                srcSet={`${establishment.ambianceImage["1000x563"]} 1x, ${establishment.ambianceImage["2000x1125"]} 2x`}
                                            />
                                            <img
                                                className="image"
                                                width="1000"
                                                height="563"
                                                alt={establishment.title}
                                                src={
                                                    establishment.ambianceImage[
                                                        "2000x1125"
                                                    ]
                                                }
                                            />
                                        </picture>
                                    </figure>
                                )}
                        </div>
                        <div className="layout__cell unit-5-12--desk unit-6-12--lap pull-1-12--desk unit-1-1 sign">
                            <h2 className="heading sign">
                                {ss.i18n._t(
                                    "EstablishmentApp.MANAGERS_HEADING"
                                )}
                            </h2>
                            <div className="layout layout--fit layout--gutter">
                                {establishment.managers.map(
                                    (manager, index) => (
                                        <div
                                            className="layout__cell unit-6-12 sign"
                                            key={index}
                                        >
                                            <div className="card">
                                                <div className="card__visual">
                                                    <figure className="visual ratio--1x1">
                                                        {manager.image[
                                                            "200x200"
                                                        ] &&
                                                            manager.image[
                                                                "400x400"
                                                            ] && (
                                                                <picture
                                                                    className="picture"
                                                                    data-default-src={
                                                                        manager
                                                                            .image[
                                                                            "200x200"
                                                                        ]
                                                                    }
                                                                >
                                                                    <source
                                                                        srcSet={`${manager.image["200x200"]} 1x, ${manager.image["400x400"]} 2x`}
                                                                    />
                                                                    <img
                                                                        className="image"
                                                                        width="200"
                                                                        height="200"
                                                                        alt={
                                                                            manager.name
                                                                        }
                                                                        src={
                                                                            manager
                                                                                .image[
                                                                                "400x400"
                                                                            ]
                                                                        }
                                                                    />
                                                                </picture>
                                                            )}
                                                    </figure>
                                                </div>
                                                <div className="card__body">
                                                    <div className="card__main">
                                                        <div className="module">
                                                            <div className="heading-xs">{`${manager.firstName} ${manager.surname}`}</div>
                                                            <p className="text-narrow">
                                                                {
                                                                    manager.jobTitle
                                                                }
                                                                {manager.phoneNumber && (
                                                                    <>
                                                                        <br />
                                                                        <a
                                                                            href={`tel:${manager.phoneNumberLink}`}
                                                                            rel="noindex"
                                                                        >
                                                                            {
                                                                                manager.phoneNumber
                                                                            }
                                                                        </a>
                                                                    </>
                                                                )}
                                                                {manager.email && (
                                                                    <>
                                                                        <br />
                                                                        <a
                                                                            href={`mailto:${manager.email}`}
                                                                            title={
                                                                                manager.email
                                                                            }
                                                                            rel="noindex"
                                                                        >
                                                                            {ss.i18n._t(
                                                                                "EstablishmentApp.MANAGER_MAILTO_LABEL"
                                                                            )}
                                                                        </a>
                                                                    </>
                                                                )}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

EstablishmentManagers.propTypes = {
    establishment: PropTypes.shape({
        id: PropTypes.number,
        ambianceImage: PropTypes.object,
        title: PropTypes.string,
        address: PropTypes.object,
        managers: PropTypes.array,
    }).isRequired,
};

export default EstablishmentManagers;
